var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasReserve)?_c('v-btn',{staticClass:"text-capitalize",attrs:{"depressed":"","rounded":"","small":"","color":"#E4E6EB"},on:{"click":_vm.reserve}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-table-chair")]),_c('span',[_vm._v("Reserve")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }